<template>
	<div class="onboarding-checklist">
		<div class="beacon" @click="toggleChecklist()">
			<div class="label">
				{{ tour.name }}
			</div>
		</div>
		<div class="checklist-main" :class="{'expanded': expanded}">
			<div class="checklist-container">
				<div class="checklist-header">
					<div class="header-content">
						<h2 class="title">{{ tour.name }}</h2>
						<div class="desc">
							{{ tour.description }}
						</div>
						<div class="progress-container"><span class="completed-caption">{{ completionPercent }}%</span><span
							class="progress-bar">
							<span class="progress-bar-complete" :style="'width: ' + completionPercent + '%;'"></span></span>
						</div>
					</div>
					<div class="minimize" @click="toggleChecklist()">
						<svg width="16px" height="16px" viewBox="0 0 16 16">
							<defs></defs>
							<g id="Icon-Arrow-Down" stroke="none" fill="#999">
								<path
									d="M7.18944314,11.1875067 L3.20507764,7.20314121 C3.06835906,7.06642263 3,6.9004077 3,6.70509552 C3,6.50978333 3.06835906,6.3437684 3.20507764,6.20704983 L3.87890415,5.56252012 C4.01562273,5.42580154 4.18163766,5.35744248 4.37694984,5.35744248 C4.57226203,5.35744248 4.73827696,5.42580154 4.87499553,5.56252012 L7.68748882,8.37501341 L10.4999821,5.56252012 C10.6367007,5.42580154 10.8027156,5.35744248 10.9980278,5.35744248 C11.19334,5.35744248 11.3593549,5.42580154 11.4960735,5.56252012 L12.1699,6.20704983 C12.3066186,6.3437684 12.3749776,6.50978333 12.3749776,6.70509552 C12.3749776,6.9004077 12.3066186,7.06642263 12.1699,7.20314121 L8.18553451,11.1875067 C8.04881594,11.3242253 7.88280101,11.3925843 7.68748882,11.3925843 C7.49217664,11.3925843 7.32616171,11.3242253 7.18944314,11.1875067 Z"
									id="" fill="#999"></path>
							</g>
						</svg>
					</div>
				</div>
				<div class="checklist-body center row">
					<div class="btn btn-gold"  @click="continuateOnboarding()">
						<span>Continuer le tutoriel</span>
					</div>
				</div>
				<div class="checklist-footer">
					<div class="skip-link left" @click="stopOnboarding()">
						Arrêter le tutoriel
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OnboardingChecklist',
	props: {
		tour: {
			type: Object
		},
		stepIndex: {
			type: Number
		}
	},
	data () {
		return {
			expanded: false
		}
	},
	methods: {
		toggleChecklist () {
			this.expanded = !this.expanded
		},

		stopOnboarding () {
			this.expanded = false
			this.$emit('stop-onboarding')
		},

		continuateOnboarding () {
			this.expanded = false
			this.$emit('continuate-onboarding')
		}
	},
	computed: {

		completionPercent () {
			return this.tour ? Math.round(((this.stepIndex + 1) / this.tour.steps.length) * 100) : 0
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/components/Onboarding/OnboardingChecklist.vue